// extracted by mini-css-extract-plugin
export var centerText = "_fv-8";
export var container = "_fv-0";
export var doughnutContainer = "_fv-7";
export var legend = "_fv-a";
export var legendItemColorDisplay = "_fv-b";
export var legendItemLabel = "_fv-d";
export var legendItemValue = "_fv-c";
export var lg = "_fv-5";
export var maxWidth = "_fv-9";
export var md = "_fv-4";
export var responsive = "_fv-6";
export var sm = "_fv-3";
export var xs = "_fv-2";
export var xxs = "_fv-1";